import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import UpdateUserEmailPreferences from 'buyside/graphql/mutations/UpdateUserEmailPreferences';
import UpdateUserFundSearchAlert from 'buyside/graphql/mutations/UpdateUserFundSearchAlert';
import UpdateUserIdeaSearchAlert from 'buyside/graphql/mutations/UpdateUserIdeaSearchAlert';

import EmailSubscriptionForm from 'buyside/components/presentation/UserAccount/EmailNotifications/emailSubscriptionForm';

const { allCurrentEmailPreferenceTypes } = require('buyside/util/constantsFromRails.json');

const validEmailTypes = Object.keys(allCurrentEmailPreferenceTypes);

const mapEmailPreferences = currentUser => {
  const userUnsubscribedEmailTypes = currentUser.emailPreferences
    .map(el => el.emailType)
    .filter(el => validEmailTypes.includes(el));

  const initialValues = validEmailTypes.reduce((memo, el) => {
    memo[el] = !userUnsubscribedEmailTypes.includes(el);
    return memo;
  }, {});
  initialValues.all = userUnsubscribedEmailTypes.includes('all');

  const fundSearchAlerts = currentUser.fundProfileSearchAlerts.reduce((memo, el) => {
    memo[el.id] = el.active;
    return memo;
  }, {});

  const ideaSearchAlerts = currentUser.ideaSearchAlerts.reduce((memo, el) => {
    memo[el.id] = el.active;
    return memo;
  }, {});

  const ideaAlertsFrequency = currentUser.ideaSearchAlerts.length
    ? currentUser.ideaSearchAlerts[0].frequency
    : '';

  return {
    ...initialValues,
    fundSearchAlerts,
    ideaSearchAlerts,
    ideaAlertsFrequency
  };
};

const EmailSubscriptionFormContainer = ({ currentUser }) => (
  <Mutation mutation={UpdateUserEmailPreferences}>
    {mutate => {
      const updateEmailPreferences = args => mutate({ variables: args });
      return (
        <Mutation mutation={UpdateUserFundSearchAlert}>
          {mutate => {
            const updateFundSearchAlert = args => mutate({ variables: args });
            return (
              <Mutation mutation={UpdateUserIdeaSearchAlert}>
                {mutate => {
                  const updateIdeaSearchAlert = args => mutate({ variables: args });
                  const handleUpdateEmailPreferences = (args, resetForm) => {
                    Object.keys(args.fundSearchAlerts).forEach(alertId =>
                      updateFundSearchAlert({
                        fundSearchAlertId: alertId,
                        active: args.fundSearchAlerts[alertId]
                      })
                    );
                    Object.keys(args.ideaSearchAlerts).forEach(alertId =>
                      updateIdeaSearchAlert({
                        ideaSearchAlertId: alertId,
                        active: args.ideaSearchAlerts[alertId],
                        frequency: args.ideaAlertsFrequency
                      })
                    );
                    updateEmailPreferences(args).then(() => resetForm());
                  };

                  return (
                    <EmailSubscriptionForm
                      handleUpdateEmailPreferences={handleUpdateEmailPreferences}
                      currentUser={currentUser}
                      initialValues={mapEmailPreferences(currentUser)}
                    />
                  );
                }}
              </Mutation>
            );
          }}
        </Mutation>
      );
    }}
  </Mutation>
);

export default EmailSubscriptionFormContainer;
